import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchSingleProduct } from "../store/singleProduct"
import { useParams, useNavigate, NavLink } from "react-router-dom"
import AddToCartButton from "./AddToCartButton"
import ReviewForm from "./ReviewForm"
import "./styles/SingleProductView.css"

const SingleProductView = () => {
  const [quantity, setQuantity] = useState(1)
  const [description, setDescription] = useState("")
  const [rating, setRating] = useState()
  const product = useSelector((state) => state.singleProduct)
  const dispatch = useDispatch()
  const { id } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(fetchSingleProduct(id))
  }, [dispatch, id])

  const addToCart = (event) => {
    event.preventDefault()
    //add to cart function
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    const newReview = { description, rating }

    dispatch(createReview(newReview))

    setDescription("")
    setRating("")
  }

  const starArr = Array.from(Array(5).keys())

  const handleReturn = () => {
    navigate(-1) // to go back to the previous page
  }

  return !product.id ? (
    <>
      <h1 className="product-not-found">Product Not Found</h1>
      <NavLink
        to={"/"}
        className={({ isActive, isPending }) =>
          `return-link ${isActive ? "return-link-active" : ""}`
        }
      >
        Return to Previous Page
      </NavLink>
    </>
  ) : (
    <div className="single-product-container">
      <div className="product-title">{product.name}</div>
      <hr />
      <div className="product-details">
        <div className="product-card">
          <figure>
            <img src={product.imageURL} alt={product.name} />
          </figure>
          <div className="product-card-body">
            <p className="product-description">{product.description}</p>
            <span className="product-price-badge">
              <span className="product-price-text">$</span>
              <span className="product-price">{product.price}</span>
            </span>
            <form
              className="product-quantity-form"
              onSubmit={(event) => event.preventDefault()}
            >
              <input
                className="product-quantity-input"
                value={quantity}
                onChange={(event) => setQuantity(event.target.value)}
              />
              <div className="product-card-actions">
                <AddToCartButton
                  product={product}
                  quantity={parseInt(quantity)}
                />
              </div>
            </form>
          </div>
        </div>
        <ReviewForm />
      </div>
    </div>
  )
}

export default SingleProductView
